// extracted by mini-css-extract-plugin
export var img = "BandSlider-theme-module--img--1b54f BandSlider-module--img--accbd";
export var root = "BandSlider-theme-module--root--a2b99 BandSlider-module--root--74ca7";